import { PaymentPlanPreview } from '@/components/public/PaymentPlanPreview';
import { useQuoteActions } from '../quoteActionContext';

// Payment Schedule v1.0 §5.2 — payment plan preview + consent. Rendered at both
// the itemized inline approve step and the single-scope approve modal from a
// single source, so the money-critical consent wiring lives in one place.
export function PaymentPlanSlot() {
  const {
    id,
    estimate,
    documentCompany,
    consentGranted,
    setConsentGranted,
    setConsentRequired,
    acceptMembershipOffer,
    membershipOffer,
  } = useQuoteActions();

  return (
    <PaymentPlanPreview
      estimateId={id}
      tenantId={estimate.tenantId}
      companyName={documentCompany?.name ?? 'Your company'}
      consentChecked={consentGranted}
      onConsentChange={setConsentGranted}
      onConsentRequiredChange={setConsentRequired}
      acceptMembershipOffer={acceptMembershipOffer}
      // The option the customer picked, not the snapshot default — the approval
      // is priced from this, so the consent they read must be too.
      membershipBillingOptionId={membershipOffer?.billingOptionId ?? null}
    />
  );
}
